<template>
  <vx-card class="p-0 overflow-hidden review">
    <div class="vx-row">
      <div class="vx-col w-1/5 p-0">
        <div class="author-image-wrapper">
          <img class="w-full" :src="item.profile_photo_url" />
        </div>
      </div>
      <div class="vx-col w-4/5">
        <p v-if="show" class="full-comment">{{item.text}}</p>
        <h5 class="author_name">{{item.author_name}}</h5>
        <span class="relative_time_description">{{item.relative_time_description}}</span>
        <star-rating :show-rating="false" :rating="item.rating" :star-size="14" read-only />
        <p class="comment">{{item.text}}...</p>
        <u><span class="cursor-pointer" v-if="item.text.length > 50" @click="show = !show">{{(show) ? 'Read less' : 'Read more'}}</span></u>
      </div>
    </div>
  </vx-card>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  props: {
    item: {
      type: Object
    }
  },
  components: {
    StarRating
  },
  data () {
    return {
      show: false
    }
  },
  name: 'CustomerReview'
}
</script>

<style lang="scss" >
  .full-comment {

    position: absolute;
    z-index: 1;
    background: white;
    overflow: auto;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
  .review .vx-card {
    box-shadow: unset;
  }
  .review .comment {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 42px;
  }

  .review p::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px #ffffff;
    border-radius: 10px;
    background-color: #ffffff;
  }

  .review p::-webkit-scrollbar
  {
    width: 3px;
    height: 3px;
    background-color: #F5F5F5;
  }

  .review p::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #9c9c9c;
    background-color: #f2f2f2;
  }

  .review .author_name {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
</style>
